import React, { useState, useEffect, useCallback } from "react";
import { useLoading } from "../../../../context/LoadingContext";
import { useNavigate } from "react-router-dom";
import DataTable from "../../../Requirement/components/common/ReusableTable";

import {
  getCurrencyRates,
  convertToBaseCurrency,
  formatData,
  fetchData,
  searchfetchQueries,
  postQuery,
} from "../../../../services/BackendServices";

import dayjs from "dayjs";
import SearchFilter from "../../../Requirement/components/common/SearchFilter";
import OfferDetails from "./OfferDetails";
import AlertModal from "../../../Requirement/components/common/AlerModel";
import { v4 as uuidv4 } from "uuid";

import TrustScoreModal from "../../../../components/common/TrustScoreModal";

const MatchingOffers = ({ requirementDetails, activeUser, onResponse }) => {
  const navigate = useNavigate();
  const { setLoading, loading } = useLoading();
  const [offerList, setOfferList] = useState([]);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [productList, setProductList] = useState([]);
  const [productGradeList, setProductGradeList] = useState([]);
  const [rowStart, setRowStart] = useState(0);
  const [pageSize] = useState(5);
  const [totalItems, setTotalItems] = useState(0);
  const [productDetails, setProductDetails] = useState({});
  const [error, setError] = useState(null);
  const [INRToUsd, setINRToUSD] = useState(0.012);
  const [searchValues, setSearchValues] = useState({
    searchOfferProduct: "",
    searchOfferProductGrade: "",
    searchPriceRange: "",
  });

  const priceOptions = [
    { value: "", label: "Select Range" },
    { value: "0-1000", label: "0-1000 USD" },
    { value: "1000-2000", label: "1000-2000 USD" },
    { value: "2000-5000", label: "2000-5000 USD" },
    { value: "Above-5000", label: "Above 5000 USD" },
  ];

  const [modal, setModal] = useState({
    show: false,
    type: "info",
    title: "",
    message: "",
    nextAction: null,
    autoClose: null,
  });

  // State for Verification Status Modal
  const [trustModal, setTrustModal] = useState(false);

  // Load currency rates when component mounts
  useEffect(() => {
    getCurrencyRates();
  }, []);

  const handleModalClose = () => {
    const action = modal.nextAction;
    setModal((prev) => ({ ...prev, show: false, nextAction: null }));
    if (action) action();
  };

  const loadProductList = useCallback(async () => {
    setLoading(true);
    console.log("@requirementDetails", requirementDetails);
    try {
      const [initialResponse] = await Promise.all([
        fetchData({
          target: "listProducts",
          userOrder: "ProductName",
          rowStart: 0,
          pageSize: 1,
          filterTerms: {
            Status: "ACTIVE",
            ProductID: requirementDetails.ProductID,
          },
        }),
      ]);

      const totalCount = initialResponse?.total || initialResponse?.length || 0;

      if (totalCount > 0) {
        const [allProducts] = await Promise.all([
          searchfetchQueries({
            target: "listProducts",
            userOrder: "ProductName",
            rowStart: 0,
            pageSize: totalCount,
            filterTerms: {
              Status: "ACTIVE",
              ProductID: requirementDetails.ProductID,
            },
          }),
        ]);

        const distinctProducts = Array.from(
          new Map(allProducts.map((p) => [p.ProductName, p])).values()
        );
        setProductList(distinctProducts);
      } else {
        setProductList([]);
      }
    } catch (error) {
      console.error("Error loading products: ", error);
    } finally {
      setLoading(false);
    }
  }, [setLoading, requirementDetails]);

  const loadProductGrades = useCallback(
    async (productName) => {
      setLoading(true);
      try {
        const [allGrades] = await Promise.all([
          fetchData({
            target: "listProducts",
            userOrder: "ProductName",
            rowStart: 0,
            pageSize: 500,
            filterTerms: { ProductName: productName },
          }),
        ]);
        if (allGrades.items.length > 0) {
          setProductGradeList(allGrades.items);
        } else {
          setProductGradeList([]);
        }
      } catch (error) {
        console.error("Error loading product grades: ", error);
      } finally {
        setLoading(false);
      }
    },
    [setLoading]
  );

  const getRequirementProductInfo = useCallback(async (requirementDetails) => {
    try {
      const response = await fetchData({
        target: "listProducts",
        userOrder: "ProductID",
        rowStart: 0,
        pageSize: 1,
        filterTerms: { ProductID: requirementDetails.ProductID },
      });

      console.log("response.items@@", response.items);
      console.log(
        "requirementDetails.ProductID@@",
        requirementDetails.ProductID
      );

      setProductDetails(response.items?.[0] || {});
    } catch (error) {
      console.error("Error loading product info:", error);
      setProductDetails([]);
    }
  }, []);

  const fetchMatchingOffers = useCallback(
    async (searchValues, newRowStart = rowStart) => {
      setLoading(true);
      setError(null);
      try {
        let priceFilter = {};
        if (searchValues.searchPriceRange) {
          if (searchValues.searchPriceRange === "Above-5000") {
            priceFilter = { CIFSalePriceGTE: 5000 };
          } else {
            const searchPrice = searchValues.searchPriceRange;
            const [min, max] = searchPrice
              .split("-")
              .map((val) => parseFloat(val));
            priceFilter = {
              CIFSalePriceGTE: min,
              CIFSalePriceLTE: max,
            };
          }
        }

        const quantity = parseFloat(requirementDetails.Quantity) || 0;
        const quantityRange = Math.max(50, quantity * 0.05);
        const destinationCountry =
          requirementDetails.DeliveryLocation?.split("~")[0] || "";

        console.log("productDetails@@", productDetails);
        const today = new Date().toISOString().split("T")[0];
        const body = {
          target: "listBuyerItemDetails",
          userOrder: "CreatedAt DESC",
          rowStart: newRowStart,
          pageSize: pageSize,
          filterTerms: {
            ValidUntilGTE: "'" + today + "'",
            GPOOfferStatus: "Indicative",
            product: productDetails.ProductName,
            grade: productDetails.Grade,
            DestinationCountry: destinationCountry,
            OriginCountry: requirementDetails.OriginCountry || "",
            QuantityGT: quantity - quantityRange,
            QuantityLT: quantity + quantityRange,
            ...priceFilter,
          },
        };

        const response = await fetchData(body);
        if (Array.isArray(response.items) || Array.isArray(response)) {
          setOfferList(response.items || response || []);
          setTotalItems(response.total || 0);
        } else {
          throw new Error("Unexpected response format");
        }
      } catch (error) {
        console.error("Error loading matching offers:", error);
        setError("Failed to load matching offers. Please try again.");
        setOfferList([]);
        setTotalItems(0);
      } finally {
        setLoading(false);
      }
    },
    [pageSize, rowStart, setLoading, productDetails]
  );

  const fields = [
    // {
    //   name: "searchOfferProduct",
    //   label: "Product",
    //   type: "dropdown",
    //   options: productList.map((item) => ({
    //     value: item.ProductName,
    //     label: item.ProductName,
    //   })),
    //   value: searchValues.searchOfferProduct,
    //   onChange: (value) => {
    //     setSearchValues((prev) => ({ ...prev, searchOfferProduct: value }));
    //     loadProductGrades(value);
    //   },
    // },
    // {
    //   name: "searchOfferProductGrade",
    //   label: "Product Grade",
    //   type: "dropdown",
    //   options: productGradeList.map((item) => ({
    //     value: item.Grade,
    //     label: item.Grade,
    //   })),
    //   value: searchValues.searchOfferProductGrade,
    //   onChange: (value) => {
    //     setSearchValues((prev) => ({
    //       ...prev,
    //       searchOfferProductGrade: value,
    //     }));
    //   },
    // },
    {
      name: "searchPriceRange",
      label: "Price Range (USD)",
      type: "dropdown",
      options: priceOptions,
      value: searchValues.searchPriceRange,
      onChange: (value) => {
        setSearchValues((prev) => ({ ...prev, searchPriceRange: value }));
        fetchMatchingOffers({ ...searchValues, searchPriceRange: value }, 0);
      },
    },
  ];

  const handlePageChange = useCallback(
    (page) => {
      const newRowStart = (page - 1) * pageSize;
      console.log("Page changed to:", page, "newRowStart:", newRowStart);
      setRowStart(newRowStart);
      fetchMatchingOffers(searchValues, newRowStart);
    },
    [pageSize, fetchMatchingOffers, searchValues]
  );

  const handleRowClick = useCallback((row) => {
    console.log("Row clicked@@:", row);
    setSelectedOffer(row);
  }, []);

  const currentPage = Math.floor(rowStart / pageSize) + 1;

  const formatPrice = (value) => {
    if (!value || value === "") return "0.00";
    const numValue = parseFloat(value);
    return isNaN(numValue) ? "0.00" : numValue.toFixed(2);
  };

  // Format date to DD/MM/YYYY format
  const formatDate = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString; // Return original if invalid date

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
      const year = date.getFullYear();

      return `${day}/${month}/${year}`; // Returns DD/MM/YYYY format
    } catch (error) {
      return dateString; // Return original string if parsing fails
    }
  };
  // Define table columns
  const columns = [
    { id: "OfferNumber", numeric: false, label: "Offer No." },
    { id: "ProductName", numeric: false, label: "Product" },
    { id: "Grade", numeric: false, label: "Grade" },
    {
      id: "Quantity",
      numeric: true,
      label: "Quantity (MT)",
      renderCell: (row) => formatPrice(row.Quantity),
    },
    {
      id: "FOBSalePrice",
      numeric: true,
      label: "FOB Sale Price (USD)",
      renderCell: (row) => row.FOBSalePrice,
    },
    { id: "Country", numeric: false, label: "Origin Country" },
    { id: "DestinationCountry", numeric: false, label: "Destination" },
    { id: "INCO", numeric: false, label: "INCO Terms" },
    // { id: "OfferType", numeric: false, label: "Offer Type" },
    {
      id: "GPOOfferStatus",
      numeric: false,
      label: "Offer Status",
      renderCell: (row) => {
        let bgColor = "";
        let textColor = "";

        switch (row.GPOOfferStatus) {
          case "BAFO":
            bgColor = "#e0f2fe";
            textColor = "#0369a1";
            break;
          case "Firmoffer":
            bgColor = "#d1fae5";
            textColor = "#065f46";
            break;
          default:
            bgColor = "#fef3c7";
            textColor = "#b45309";
            row.GPOOfferStatus = "Indicative";
            break;
        }

        return (
          <span
            style={{
              backgroundColor: bgColor,
              color: textColor,
              padding: "4px 10px",
              borderRadius: "999px",
              fontSize: "0.75rem",
              fontWeight: 500,
            }}
          >
            {row.GPOOfferStatus}
          </span>
        );
      },
    },
    {
      id: "CreatedAt",
      numeric: false,
      label: "Created Date",
      renderCell: (row) => formatDate(row.CreatedAt),
    },
    {
      id: "Expires",
      numeric: false,
      label: "Expires",
      renderCell: (row) => formatDate(row.Expires),
    },
    {
      id: "KYBStatus",
      numeric: false,
      label: "Seller Status",
      renderCell: (row) => {
        let bgColor = "";
        let textColor = "";

        switch (row.KYBStatus) {
          case "Approved":
            bgColor = "#d1fae5";
            textColor = "#065f46";
            break;
          default:
            bgColor = "#fef3c7";
            textColor = "#b45309";
        }

        return (
          <span
            style={{
              backgroundColor: bgColor,
              color: textColor,
              padding: "4px 10px",
              borderRadius: "999px",
              fontSize: "0.75rem",
              fontWeight: 500,
              display: "inline-block",
            }}
          >
            {row.KYBStatus === "Approved" ? "Verified" : "Unverified"}
          </span>
        );
      },
    },
  ];

  const trustModel = useCallback(() => {
    setTrustModal(true);
  }, []);

  const handleSearch = (searchValues) => {
    setRowStart(0);
    fetchMatchingOffers(searchValues, 0);
  };

  useEffect(() => {
    const initializeData = async () => {
      await getRequirementProductInfo(requirementDetails);
    };
    initializeData();
  }, [getRequirementProductInfo, requirementDetails]);

  useEffect(() => {
    console.log(
      "Triggering fetchMatchingOffers with productDetails:",
      productDetails
    );
    if (productDetails && productDetails.ProductName) {
      fetchMatchingOffers(searchValues, rowStart);
    }
  }, [productDetails, searchValues]);

  const Button = ({ label, onClick, disabled = false }) => {
    return (
      <button
        className="btn-action-re"
        onClick={onClick}
        disabled={disabled}
        style={disabled ? { opacity: 0.5, cursor: "not-allowed" } : {}}
      >
        {label}
      </button>
    );
  };

  const sendTrueToParent = () => {
    console.log("child sendTrueParent");
    //Response(true); // Sends true to parent via callback
  };

  const handleRaiseRFQ = async (offer) => {
    console.log("handleRaiseRFQ triggered");
    console.log("raiseRfqOffer::", offer);
    setModal({
      show: true,
      type: "warning",
      title: "Confirm Submission",
      message: "Are you sure you want to create trade RFQ of this offer?",
      isConfirm: true,
      confirmButtonText: "Confirm",
      cancelButtonText: "Skip",
      onConfirm: async () => {
        console.log("Confirm chosen...");
        console.log("#productDetails:", productDetails);
        let insertedRequirementsID = null;
        let insertedRequirementsNo = null;
        const insertedPaymentConditionsIDs = [];
        // setSubmitted(true);
        setLoading(true);

        try {
          let totalTrfqItems = 0;
          try {
            const bodyTradeRfq = {
              target: "listRequirements",
              userOrder: "RequirementsID",
              rowStart: 0,
              pageSize: 1,
              filterTerms: {
                CategoryType: "rfq",
              },
            };
            const responseTradeRfq = await fetchData(bodyTradeRfq);
            totalTrfqItems = responseTradeRfq.total || 0;
          } catch (error) {
            console.error("Error loading RFQs: ", error);
            totalTrfqItems = 0;
          }

          const packageingValue = {
            item: offer.PackagingType,
            size: offer.PackagingSize,
          };
          const curreDate = new Date();
          const reqNoDate = dayjs(curreDate).format("YYYYMMDD");
          const reqCount = totalTrfqItems + 1;
          const reqNumber = reqNoDate + reqCount;

          console.log("@@@", packageingValue, reqNumber);

          const requestedQuantityValue = parseInt(offer.Quantity || 0);
          const requestedProductID = offer.ProductID || "";
          const categoryValue = productDetails.ProductCategoryID || "";
          const productType = "";
          const priceOfferedValue =
            convertToBaseCurrency(offer.Price, offer.Currency || "INR") ||
            "0.00";
          const deliveryPeriodTillValue = offer.ExpiryDate || "";
          const deliveryPeriodFromValue =
            dayjs(curreDate).format("YYYY-MM-DD 00:00:00") || "";
          const validUntilValue = offer.Expires || "";
          const incotermValue = offer.INCO || "";
          const destinationCountry = offer.DestinationCountry || "";
          const deliveryPortValue = offer.DischargePort || "";
          const locationsValue = destinationCountry + "~" + deliveryPortValue;
          const originCountryValue = offer.OriginCountry || "";

          let gpEmail = offer.GPEmailID || "";

          let recordStatus = "Draft";

          const selectedDocsString = " ";

          //   //insert
          const body = {
            target: "createRequirements",
            ExtraInfo: {
              ProductName: productDetails?.ProductName,
              Grade: productDetails?.Grade,
            },
            requirementsInput: {
              RequirementsID: uuidv4(),
              RequirementNumber: reqNumber,
              GPEmailID: gpEmail,
              BuyerEmailID: activeUser,
              CreatedByEmailID: activeUser,
              ProductID: requestedProductID,
              Quantity: requestedQuantityValue,
              Price: priceOfferedValue,
              DeliveryDate: deliveryPeriodTillValue,
              RequirementDate: dayjs(curreDate).format("YYYY-MM-DD"),
              MarketPlacement: "No",
              ValidUntil: validUntilValue,
              Incoterm: incotermValue,
              DeliveryLocation: locationsValue,
              DeliveryPeriodFrom: deliveryPeriodFromValue,
              DeliveryPeriodTill: deliveryPeriodTillValue,
              OriginCountry: originCountryValue,
              ProductPackaging: packageingValue,
              RequestedQuantity: requestedQuantityValue,
              PriceOffered: priceOfferedValue,
              Status: recordStatus,
              CategoryType: "rfq",
              Deleted: 0,
              Title: "RFQ generated from " + offer.OfferNumber || " ",
              CreateDate: dayjs(curreDate).format("YYYY-MM-DD 00:00:00"),
              SubmitedDate: dayjs(curreDate).format("YYYY-MM-DD 00:00:00"),
              HsCode: offer.HsCode || "",
              Variety: offer.Variety || "",
              ProductSpecifications: offer.productSpecifications || " ",
              AdditionalProductNotes: "",
              AdditionalPackagingNotes: offer.AdditionalPackagingNotes || " ",
              ShippingMethodPreference: offer.ShippingMethodPreference || " ",
              PartialDeliveryAllowed: offer.PartialDeliveryAllowed || 0,
              AdditionalLogisticsNotes: offer.TransitTime || " ",
              UnloadingResponsibility: offer.UnloadingResponsibility || "",
              TransshipmentAllowed: 0,
              PreferredPaymentMethod: offer.PreferredPaymentMethod || "",
              Currency: offer.Currency || "",
              PaymentTimeline: offer.PaymentTerms || " ",
              SpecialInstructionsSuppliers:
                offer.SpecialInstructionsBuyer || " ",
              QualityInspectionRequired: 0,
              InternalComments: offer.Internalcomments || " ",
              RequiredSupplierCertifications: 0,
              ComparisonCriteriaPriority: " ",
              RequiredDocuments: selectedDocsString,
            },
          };

          const result = await postQuery(body);
          console.log(result);
          if (!result || !result.items)
            throw new Error("Failed to create RFQ.");

          insertedRequirementsID = result.items.RequirementsID;
          insertedRequirementsNo = result.items.RequirementNumber;
          console.log(insertedRequirementsID);
          const bodyProductInfo = {
            target: "createRequirementProductInfo",
            requirementProductInfoInput: {
              RequirementProductInfoID: uuidv4(),
              RequirementsID: insertedRequirementsID,
              Category: categoryValue,
              ProductID: requestedProductID,
              ProductTypeID: productType,
              Deleted: 0,
            },
          };
          await postQuery(bodyProductInfo);

          const bodyRTH = {
            target: "createRequirementTxnHistory",
            requirementTxnHistoryInput: {
              RequirementTxnHistoryID: uuidv4(),
              RequirementsID: insertedRequirementsID,
              ActionedByEmail: activeUser,
              Status: recordStatus,
              Deleted: 0,
            },
          };
          await postQuery(bodyRTH);

          setModal({
            show: true,
            type: "success",
            title: "Success!",
            message: `RFQ ${insertedRequirementsNo} created successfully.`,
            autoClose: false,
            nextAction: () => {
              navigate("/buyer/requirement");
              // setIsFormVisible(false);
              // searchRFQs(searchValues);
            },
          });
        } catch (error) {
          console.error("Submission error:", error);
          try {
            await Promise.all(
              insertedPaymentConditionsIDs.map(async (paymentConditionsID) => {
                const bodyDelPC = {
                  target: "deletePaymentConditions",
                  PaymentConditionsID: paymentConditionsID,
                };
                await postQuery(bodyDelPC);
              })
            );
            if (insertedRequirementsID) {
              const bodyDelR = {
                target: "deleteRequirements",
                RequirementsID: insertedRequirementsID,
              };
              await postQuery(bodyDelR);
            }
          } catch (rollbackError) {
            console.error("Rollback error:", rollbackError);
            setModal({
              show: true,
              type: "error",
              title: "Rollback Error!",
              message:
                "Failed to clean up data after error. Please contact support.",
              autoClose: false,
            });
            setLoading(false);
            // setSubmitted(false);
            return;
          }

          setModal({
            show: true,
            type: "error",
            title: "Error!",
            message: error.message || "Failed to submit RFQ.",
            autoClose: false,
          });
        } finally {
          setLoading(false);
          //   setSubmitted(false);
        }
      },
      onCancel: async () => {
        // If not confirmed, proceed with original else block
        console.log("Cancel chosen...");
        handleModalClose();
      },
    });
  };

  const handleShortlist = async (offer) => {
    setLoading(true);
    console.log("handleShortlist triggered");
    console.log("shortlistOffer::", offer);
    try {
      // Simulate API call with a 1-second delay
      let body = null;
      console.log("Saving data to API:", offer);

      body = {
        target: "buyerShortlistOffer",
        BuyerItemExtendedInput: {
          BuyerItemID: offer.BuyerItemID,
          OfferStatus: "Shortlist",
          Deleted: 0,
          CategoryType: "requirement",
          GPEmailID: activeUser,
          RequirementsID: requirementDetails.RequirementsID,
        },
      };

      console.log("Saving body to API:", body);
      if (body !== null) {
        const result = await postQuery(body, "backendops");
        console.log("result@", result);
        if (result) {
          setModal({
            show: true,
            type: "success",
            title: "Success",
            message: `Offer shortlisted successfully!`,
            autoClose: false,
            nextAction: () => {
              sendTrueToParent();
              setSelectedOffer(null);
            },
          });
        }
      }

      // Refresh the table data
      await fetchMatchingOffers(searchValues, rowStart);
    } catch (error) {
      console.error("Error saving data:", error);
      setModal({
        show: true,
        type: "error",
        title: "Error",
        message: `Failed to set shortlist`,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="matching-offers-container" style={{ marginTop: "20px" }}>
      <AlertModal
        type={modal.type}
        title={modal.title}
        message={modal.message}
        showModal={modal.show}
        onClose={handleModalClose}
        onConfirm={modal.onConfirm}
        onCancel={modal.onCancel}
        isConfirm={modal.isConfirm}
        buttonText="OK"
        autoClose={modal.autoClose}
      />
      <div className="search-filter4">
        <div className="title4">
          <div className="head-text">Matching Offers</div>
        </div>
        <div className="filter4">
          <SearchFilter fields={fields} onSearch={handleSearch} />
        </div>
      </div>
      {/* <div className="table-header">
        <div className="header-text">
          <div className="head-text">Matching Offers</div>
        </div>
        <div className="head-btn">
         
        </div>
      </div> */}
      {/* <div className="search-filter row">
        <SearchFilter fields={fields} onSearch={handleSearch} />
      </div> */}
      {loading && <div className="loading">Loading offers...</div>}
      {error && <div className="error-message">{error}</div>}
      {!loading && !error && offerList.length === 0 && (
        <div className="empty-state">No matching offers found.</div>
      )}
      {!loading && offerList.length > 0 && (
        <DataTable
          columns={columns}
          data={offerList}
          total={totalItems}
          title="Matching Offers Information"
          rowsPerPage={pageSize}
          onPageChange={handlePageChange}
          onRowClick={handleRowClick}
          currentPage={currentPage}
          selectedRows={
            selectedOffer ? [selectedOffer.GPOfferID || selectedOffer.id] : []
          }
        />
      )}
      {selectedOffer && (
        <div className="offer-detail1">
          <div className="header-text-re">
            <div className="head-text">Offer Details</div>
            {selectedOffer ? (
              selectedOffer.IsShortlistRequirement === 1 ? (
                <>
                  <Button label="Verification Status" onClick={trustModel} />
                  <div
                    className="shortlist-text"
                    style={{
                      background: "#de6b14",
                      color: "#fff",
                      borderRadius: "6px",
                      padding: "4px 14px",
                      display: "inline-block",
                    }}
                  >
                    Shortlisted
                  </div>
                </>
              ) : (
                <div className="button-group">
                  <Button label="Verification Status" onClick={trustModel} />
                  <Button
                    label="Shortlist"
                    onClick={() => handleShortlist(selectedOffer)}
                  />
                  <Button
                    label="Raise RFQ"
                    onClick={() => handleRaiseRFQ(selectedOffer)}
                  />
                </div>
              )
            ) : (
              <div></div>
            )}
          </div>

          <OfferDetails
            offer={selectedOffer}
            btnShortlist={false}
            btnSendQuery={false}
            btnRequestQuote={false}
            btnRequestSpecifications={false}
            btnRequestBestPrice={false}
            btnNegotiate={false}
            btnRequestShippingDetails={false}
            btnLogisticsSupport={false}
            btnRaiseQuery={true}
            breakupTab={true}
          />
        </div>
      )}
      {/* Verification Status Modal */}
      {trustModal && (
        <TrustScoreModal
          onClose={() => setTrustModal(false)}
          userEmail={selectedOffer.SellerEmailID}
        />
      )}
    </div>
  );
};

export default MatchingOffers;
